// Rotas da aplicacao — AppShell como parent, children lazy-loaded.
import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import NotFound from "@/routes/NotFound";
import { AppShell } from "@/components/layout";

const BrandPage = lazy(() => import("@/features/brand"));
const WizardPage = lazy(() => import("@/features/wizard"));
const RankingPage = lazy(() => import("@/features/ranking"));
const DashboardPage = lazy(() => import("@/features/dashboard"));

function PageSpinner() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        color: "var(--ink-400)",
        fontSize: "var(--t-sm)",
        fontFamily: "var(--font-mono)",
      }}
    >
      carregando...
    </div>
  );
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<PageSpinner />}>
        <AppShell />
      </Suspense>
    ),
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<PageSpinner />}>
            <BrandPage />
          </Suspense>
        ),
      },
      {
        path: "wizard",
        element: (
          <Suspense fallback={<PageSpinner />}>
            <WizardPage />
          </Suspense>
        ),
      },
      {
        path: "ranking",
        element: (
          <Suspense fallback={<PageSpinner />}>
            <RankingPage />
          </Suspense>
        ),
      },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<PageSpinner />}>
            <DashboardPage />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
